<template>
  <div class="article-wrapper">
    <div class="article-card">
      <div class="article-header">
        <h5>{{ header }}</h5>
      </div>

      <div v-if="article" class="article-img-holder">
        <img :src="image" class="article-img" />
      </div>
      <div class="article-content">
        <p class="subheader-text" v-html="subHeader"></p>

        <a v-if="article" class="story-expander" @click="toggleStoryExpansion">
          <img
            :src="require('../assets/icons/expand-icon.png')"
            class="expand-icon"
            :class="{ 'expand-icon--rotated': storyExpanded }"
          />{{ $language.current | translateToCurrentLang(article.titleEs, article.titleEn) }}
        </a>

        <transition v-if="article" name="slide-fade">
          <div v-if="storyExpanded" class="article-expanded-story">
            <p>
              {{ $language.current | translateToCurrentLang(article.textEs, article.textEn) }}
            </p>
          </div>
        </transition>
      </div>
      <div class="article-footer">
        <div class="divider" />

        <div class="article-button-section">
          <md-button @click="$emit('click')" class="md-dense md-raised article-button">{{
            buttonText.toUpperCase()
          }}</md-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ImpactStory from '@/services/impactStories'
import { analyticsMixin } from '@/services/googleAnalytics'

const defaultRequestStoryImage = require('../assets/images/diary-coffee.jpg')
const defaultContributionStoryImage = require('../assets/images/jude-beck.jpg')

export default {
  name: 'ArticleCard',
  mixins: [analyticsMixin],
  props: {
    header: {
      required: true,
      type: String,
    },
    subHeader: {
      required: true,
      type: String,
    },
    article: {
      required: false,
      type: Object,
    },
    buttonText: {
      required: true,
      type: String,
    },
  },
  data() {
    return {
      storyExpanded: false,
    }
  },
  methods: {
    toggleStoryExpansion() {
      // toggle and track CTA
      let storyType = this.article.storyType
      if (this.storyExpanded) {
        this.trackClickedCTA(`collapsed ${storyType}`)
        this.storyExpanded = false
      } else {
        this.trackClickedCTA(`expanded ${storyType}`)
        this.storyExpanded = true
      }
    },
  },
  computed: {
    image() {
      if (this.article) {
        if (this.article.storyType === ImpactStory.REQUEST_STORY) {
          return defaultRequestStoryImage
        } else if (this.article.storyType === ImpactStory.CONTRIBUTION_STORY) {
          return defaultContributionStoryImage
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/base';
@import '@/styles/variables';
@import '@/styles/mixins/buttons';
.article-wrapper {
  width: 100%;
  margin-bottom: 4rem;
}
.article-header {
  height: 4rem;
  width: 100%;
  display: flex;
  align-items: center;

  h5 {
    margin: 0 0 0 1rem;
    font-weight: normal;
    font-size: 1.1rem;
  }
}
.article-card {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
  border-bottom-left-radius: 1rem;
  border-bottom-right-radius: 1rem;
  background: var(--light-brand-color);
  box-shadow: 0 4px 8px 0 $mid-gray;
  top: -1rem;
}
.article-img-holder {
  height: 13rem;
  overflow: hidden;
  width: 100%;
  margin-bottom: 1rem;
}
.article-content {
  padding: 0rem 1rem;
  background: var(--light-brand-color);
}
.article-expanded-story {
  margin-top: 1rem;
}
.story-expander {
  display: flex;
  align-items: center;
  margin: 2rem 0 0.4rem 0;
  cursor: pointer;
}
.expand-icon {
  height: 0.8rem;
  margin-right: 0.5rem;
  -webkit-transition: 0.3s ease-in-out;
  -moz-transition: 0.3s ease-in-out;
  -o-transition: 0.3s ease-in-out;
  transition: 0.3s ease-in-out;

  &--rotated {
    transform: rotate(180deg);
  }
}
/* Enter and leave animations for the expandable story. */
.slide-fade-enter-active {
  transition: all 0.5s ease;
}
.slide-fade-leave-active {
  transition: all 0.2s ease;
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}
.divider {
  width: 100%;
  height: 1px;
  border: 1px solid $very-light-gray;
  margin-top: 1rem;
}
.article-button-section {
  height: 5rem;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.article-button {
  @include primary-button(var(--dark-brand-color));
}
</style>
